module.exports = __webpack_public_path__ + "media/assets/user-reviews-e861b86ff3fcf732bd624ba3000b493a.svg";